import { ExpenseInvoiceDocumentKind } from '../Types/expenseInvoice.types';

export const EXPENSE_INVOICE_DOCUMENT_KIND_LABELS: Record<ExpenseInvoiceDocumentKind, string> = {
  [ExpenseInvoiceDocumentKind.FullInvoice]: 'Faktura',
  [ExpenseInvoiceDocumentKind.SimplifiedCost]: 'Koszt uproszczony',
};

export const parseExpenseInvoiceDocumentKind = (
  value: ExpenseInvoiceDocumentKind | 'FullInvoice' | 'SimplifiedCost' | string | null | undefined
): ExpenseInvoiceDocumentKind | undefined | null => {
  const normalizedValue = String(value ?? '').trim().toLowerCase();

  if (normalizedValue.length === 0) {
    return undefined;
  }

  if (normalizedValue === 'simplifiedcost' || normalizedValue === 'simplified_cost') {
    return ExpenseInvoiceDocumentKind.SimplifiedCost;
  }

  if (normalizedValue === 'fullinvoice' || normalizedValue === 'full_invoice') {
    return ExpenseInvoiceDocumentKind.FullInvoice;
  }

  return null;
};

export const normalizeExpenseInvoiceDocumentKind = (
  value: ExpenseInvoiceDocumentKind | 'FullInvoice' | 'SimplifiedCost' | string | null | undefined
): ExpenseInvoiceDocumentKind => {
  const parsedValue = parseExpenseInvoiceDocumentKind(value);

  if (parsedValue === ExpenseInvoiceDocumentKind.SimplifiedCost) {
    return parsedValue;
  }

  if (parsedValue === ExpenseInvoiceDocumentKind.FullInvoice) {
    return ExpenseInvoiceDocumentKind.FullInvoice;
  }

  return ExpenseInvoiceDocumentKind.FullInvoice;
};

export const isSimplifiedExpenseInvoiceDocument = (
  value: ExpenseInvoiceDocumentKind | 'FullInvoice' | 'SimplifiedCost' | string | null | undefined
): boolean => parseExpenseInvoiceDocumentKind(value) === ExpenseInvoiceDocumentKind.SimplifiedCost;

export const isFullExpenseInvoiceDocument = (
  value: ExpenseInvoiceDocumentKind | 'FullInvoice' | 'SimplifiedCost' | string | null | undefined
): boolean => normalizeExpenseInvoiceDocumentKind(value) === ExpenseInvoiceDocumentKind.FullInvoice;
